import {PersistenceProvider} from "@/model/persistence/index";
import { ElectronStoragePersistenceProvider } from "@/model/persistence/electron-storage";

export function getPersistenceService() : PersistenceProvider {
    return new ElectronStoragePersistenceProvider()
}